/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const removeContactPathParamsSchema = z.object({
    "id": z.string().describe("Contact identifier")
    })

export const removeContactQueryParamsSchema = z.object({
    "idType": z.optional(z.enum(["internal", "external"]))
    }).optional()

export const removeContactHeaderParamsSchema = z.object({
    "x-radar-user-id": z.optional(z.string().describe("Contact owner id — required when authenticating with the service secret instead of a bearer token"))
    }).optional()

/**
 * @description Contact deleted
 */
export const removeContact204Schema = z.any()

/**
 * @description Contact not found
 */
export const removeContact404Schema = z.any()

export const removeContactMutationResponseSchema = z.lazy(() => removeContact204Schema)